import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { SiteLayout } from '../components/layout/SiteLayout'
import { useLanguage } from '../i18n/LanguageContext'

const HomePage = lazy(() => import('../pages/HomePage'))
const ProductPage = lazy(() => import('../pages/ProductPage'))
const SolutionPage = lazy(() => import('../pages/SolutionPage'))
const PricingPage = lazy(() => import('../pages/PricingPage'))
const ContactPage = lazy(() => import('../pages/ContactPage'))
const SignInPage = lazy(() => import('../pages/SignInPage'))
const AboutPage = lazy(() => import('../pages/AboutPage'))
const PlatformPage = lazy(() => import('../pages/PlatformPage'))
const BusinessPage = lazy(() => import('../pages/BusinessPage'))
const PlatformDetailPage = lazy(() => import('../pages/PlatformDetailPage'))
const SubscriptionsPage = lazy(() => import('../pages/SubscriptionsPage'))
const NotFoundPage = lazy(() => import('../pages/NotFoundPage'))

function PageLoader() {
  const { t } = useLanguage()
  return <div className="flex min-h-[60vh] items-center justify-center" role="status" aria-label={t('Loading page')}><span className="h-5 w-5 animate-spin rounded-full border-2 border-white/10 border-t-brand" /></div>
}

export function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route element={<SiteLayout />}>
          <Route index element={<HomePage />} />
          <Route path="serve" element={<ProductPage id="serve" />} />
          <Route path="pos" element={<ProductPage id="pos" />} />
          <Route path="kds" element={<ProductPage id="kds" />} />
          <Route path="waiter" element={<ProductPage id="waiter" />} />
          <Route path="connect" element={<ProductPage id="connect" />} />
          <Route path="platform" element={<PlatformPage />} />
          <Route path="business" element={<BusinessPage />} />
          <Route path="platform/products" element={<PlatformDetailPage id="products" />} />
          <Route path="platform/staff" element={<PlatformDetailPage id="staff" />} />
          <Route path="platform/multi-store" element={<PlatformDetailPage id="multi-store" />} />
          <Route path="platform/devices" element={<PlatformDetailPage id="devices" />} />
          <Route path="platform/payments" element={<PlatformDetailPage id="payments" />} />
          <Route path="subscriptions" element={<SubscriptionsPage />} />
          <Route path="solutions/:solutionId" element={<SolutionPage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="sign-in" element={<SignInPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  )
}
